import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { StatusType } from '@uigy/generated/graphql';
import { StatusDataService } from '@uigy/shared/services/statusData.service';
import { map } from 'rxjs/operators';

export const DisableGuard: CanActivateFn = () => {
  const statusDataService: StatusDataService = inject(StatusDataService);
  return statusDataService.getStatus().pipe(
    map((status: StatusType | null) => status === StatusType.Disabled),
  );
};
